// src/js/config/ui/promptDeleteModal.js

import { DOMElements } from '../dom.js';
import { activateTrap, deactivateTrap } from '../../utils/focusTrap.js';

let currentOnConfirmCallback, currentOnCancelCallback;
let originalTrigger = null;

function hideModal() {
    const { promptDeleteModal } = DOMElements;
    if (promptDeleteModal) {
        deactivateTrap();
        if (originalTrigger) originalTrigger.focus();
        promptDeleteModal.classList.remove('is-visible');
        document.body.classList.remove('modal-open');
        originalTrigger = null;
    }
}

export function showPromptDeleteModal(message, onConfirm, onCancel) {
    const { promptDeleteModal, promptDeleteMessage, promptDeleteCancelBtn } = DOMElements;
    if (!promptDeleteModal) return;

    originalTrigger = document.activeElement;
    promptDeleteMessage.innerHTML = message;
    currentOnConfirmCallback = onConfirm;
    currentOnCancelCallback = onCancel || (() => {});

    promptDeleteModal.classList.add('is-visible');
    document.body.classList.add('modal-open');
    activateTrap(promptDeleteModal);
    
    // Använd 'transitionend' för robust fokus-sättning på knappar
    promptDeleteModal.addEventListener('transitionend', () => {
        if (promptDeleteCancelBtn) promptDeleteCancelBtn.focus();
    }, { once: true });
}

export function initializePromptDeleteModal() {
    const { promptDeleteModal } = DOMElements;
    if (!promptDeleteModal) return;

    promptDeleteModal.addEventListener('click', (event) => {
        if (event.target.closest('#promptDeleteDeleteBtn')) {
            if (typeof currentOnConfirmCallback === 'function') currentOnConfirmCallback();
            hideModal();
        } else if (event.target.closest('#promptDeleteCancelBtn') || event.target === promptDeleteModal) {
            if (typeof currentOnCancelCallback === 'function') currentOnCancelCallback();
            hideModal();
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && promptDeleteModal.classList.contains('is-visible')) {
            if (typeof currentOnCancelCallback === 'function') currentOnCancelCallback();
            hideModal();
        }
    });
}